let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5KeLC")).then(() => parcelRequire('lGnF5'));